import { HourStatsActual } from '@/data/hourStats/models';
import { HourStatsActualState } from '@/data/hourStats/states';
import { DELETE_HOUR_STATS_ACTUAL, FETCH_HOUR_STATS_ACTUAL, RESET_SCHEDULER_STATE } from '@/store/action-types';

export default (state = new HourStatsActualState(), action) => {
  switch (action.type) {
    case FETCH_HOUR_STATS_ACTUAL.REQUEST:
      return state.merge({
        loading: true,
        receivedAt: 0,
      });
    case FETCH_HOUR_STATS_ACTUAL.SUCCESS:
      return state.merge({
        loaded: true,
        loading: false,
        error: null,
        receivedAt: Date.now(),
        items: state.items.merge(
          action.payload.map(hourStats => {
            return [`${hourStats.id}-${hourStats.start}`, new HourStatsActual(hourStats)];
          }),
        ),
      });
    case FETCH_HOUR_STATS_ACTUAL.FAILURE:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    case DELETE_HOUR_STATS_ACTUAL:
      return state.merge({
        items: state.items.filterNot(hourStats => action.ids.includes(`${hourStats.id}-${hourStats.start}`)),
      });
    case RESET_SCHEDULER_STATE:
      return new HourStatsActualState();
    default:
      return state;
  }
};
